import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'jquery-hoverintent';

import OneDrawer from '../modules/module-oneDrawer';

export default Backbone.View.extend({
    
    initialize: function (opts) {
        var self = this;
        self.$body = self.$el;
        self.$header = $('header.site-header');
        self.$miniCart = $('#MiniCart');

        self.miniCartAsDropdown = false; // Set false to use drawer, set true to use dropdown on Desktop (drawer on Mobile).

        self.initUtilities();
        self.initMiniCart();
        self.devTools();
        self.initGridSwatches();
        self.handleFilterMenu();
    },

    events: {
        'drawer-opt' : 'bodyClassCtl',
        'menu-opt-in' : 'bodyClassCtl',
        'menu-opt-out' : 'bodyClassCtl'
    },

    initGridSwatches: function(){
        if ($('.color-swatch-overlay').length > 0) {
            $('body').on('click', '.color-swatch-overlay div', function(e) {
                const el = $(this);
                const parentContainer = $(el).parent().parent().parent();
                if (parentContainer) {
                    $(this).parent().find('div').removeClass('active');
                    $(parentContainer).find('.grid-product__image').data('srcset', '');
                    $(parentContainer).find('.grid-product__image').attr('srcset', '');
                    $(parentContainer).find('.grid-product__image').attr('src', $(this).data('image'));
                    $(el).addClass('active');
                    e.preventDefault();
                    e.stopPropagation();
                    const path = $(parentContainer).find('a').data('orig');
                    if (path) {
                        const split = path.split('?');
                        if (split.length > 1) {
                            const replacedPath = path.split('?')[0] + '?variant=' + $(el).data('id') + '&' + path.split('?')[1];
                            $(parentContainer).find('a').attr('href', replacedPath);
                        } else {
                            $(parentContainer).find('a').attr('href', path + '?variant=' + $(el).data('id'));
                        }
                    }
                }
            });
        }
    },

    handleFilterMenu: function() {
        let params = new URLSearchParams(document.location.search);
        let ACTIVE_FILTERS = {};
        let SORT_TYPE = 'DEFAULT';
        let IS_OPEN = false;

        if (params.get('sort_by')) {
          SORT_TYPE = params.get('sort_by');

          switch (SORT_TYPE) {
            case 'created-descending':
              SORT_TYPE = 'newest';
              break;
            case 'price-ascending':
              SORT_TYPE = 'low-to-high';
              break;
            case 'price-descending':
              SORT_TYPE = 'high-to-low';
              break;
            case 'best-selling':
              SORT_TYPE = 'best-selling';
              break;
            default:
              SORT_TYPE = 'DEFAULT';
              break;
          }

          // uncheck all other sort checkboxes
          let foundSort = false;
          $('.filter-category[data-type="sort"]')
            .find('input[type="checkbox"]')
            .each(function () {
              if ($(this).attr('id') !== 'sort-' + SORT_TYPE) {
                $(this).prop('checked', false);
              } else {
                $(this).prop('checked', true);
                foundSort = true;
                // update sort type text
                $(this)
                  .closest('.filter-category')
                  .find('.filter-section-header span')
                  .text('Sort By: ' + $(this).parent().find('.filter-label').text());
              }
            });

            // fallback if not valid sort type
            if (!foundSort) {
              $('#sort-default').prop('checked', true);
              SORT_TYPE = 'DEFAULT';
            }
        }

        $('.filter-bar-inner').on('click', '.filter-bar-inner__item', function () {
          let key = ($(this).data('key'));
          let value = ($(this).data('value'));
          let filter = encodeURIComponent(key) + '=' + encodeURIComponent(value);
          let url = window.location.href;

          if (url.indexOf('?' + filter) > -1) {
            // check if there's a second param
            if (url.indexOf('?' + filter + '&') > -1) {
              url = url.replace('?' + filter + '&', '?');
            } else {
              url = url.replace('?' + filter, '');
            }
          } else if (url.indexOf('&' + filter) > -1) {
            url = url.replace('&' + filter, '');
          }

          window.location.href = url;
        });
        
        if ($('.filter-category').length) {
          $('.filter-category[data-type="sort"]')
            .find('input[type="checkbox"]')
            .click(function () {
              if ($(this).is(':checked')) {
                $(this)
                  .closest('.filter-category')
                  .find('.filter-section-header span')
                  .text('Sort By: ' + $(this).parent().find('.filter-label').text());
                SORT_TYPE = $(this).attr('id').split('sort-')[1];
        
                // uncheck other checkboxes
                const currCheckbox = $(this);
                $(this)
                  .closest('.filter-category')
                  .find('input[type="checkbox"]')
                  .each(function (el) {
                    if ($(this).attr('id') !== $(currCheckbox).attr('id')) {
                      $(this).prop('checked', false);
                    }
                  });
                $(this)
                  .closest('.filter-category')
                  .find('.filter-section-header')
                  .click();
              } else {
                $(this)
                  .closest('.filter-category')
                  .find('.filter-section-header span')
                  .text('Sort By: Default');
        
                // check default box
                $('#sort-default').prop('checked', true);
                SORT_TYPE = 'DEFAULT';
              }
            });
        
          $('.filter-category')
            .not('[data-type="sort"]')
            .find('input[type="checkbox"]')
            .click(function () {
              if ($(this).is(':checked')) {
                ACTIVE_FILTERS[$(this).data('filter')] = parseInt($(this).parent().find('.filter-individual-count').text().replace('(', '').replace(')', ''));
              } else {
                delete ACTIVE_FILTERS[$(this).data('filter')];
              }
              handleFilterButtonVisibility();
            });
        
          const clearFilters = () => {
            $('.filter-category')
              .not('[data-type="sort"]')
              .find('input[type="checkbox"]')
              .prop('checked', false);
            ACTIVE_FILTERS = {};
            handleFilterButtonVisibility();
          };
        
          $('.filter-clear').click(function () {
            clearFilters();
          });

          $('.filter-view-results').click(function () {
            generateFilterURL();
          });

          $('.js-drawer-close-2').click(function () {
            hideFilterMenu();
          });

          $('.transition-body').not('.filter-menu').click(function () {
            if (!IS_OPEN) return;
            hideFilterMenu();
          });

          $('.filter-menu').click(function (e) {
            e.stopPropagation();
          });

          $('.filter-options-list__item').click(function () {
            let filter = $(this).data('filter');
            $('.filter-section-header').removeClass('active');
            $('.filter-section-header[data-filter="' + filter + '"]').addClass('active');
            $('#filter-open').click();
          });
        
          $('.filter-section-header').click(function () {
            if ($(this).hasClass('active')) {
              $(this).removeClass('active');
            } else {
              $(this).addClass('active');
            }
          });
          $('#filter-open').click(function () {
            if ($(this).hasClass('active')) {
              hideFilterMenu();
            } else {
              if (window.innerWidth < 700) {
                slideFilterMenuRight();
              } else {
                slideFilterMenuRight();
              }
              setTimeout(() => {
                IS_OPEN = true;
              }, 300);
              $(this).addClass('active');
              $(this).find('.rotate-svg').addClass('inverted');
            }
          });
        
          const hideFilterMenu = () => {
            const menu = $('.filter-menu');
            IS_OPEN = false;
            if ($(menu).hasClass('filter-right')) {
              hideFilterMenuLeft();
            } else {
              hideFilterMenuUp();
            }
            $('#filter-open').removeClass('active');
            $('#filter-open').find('.rotate-svg').removeClass('inverted');
          };
        
          const slideFilterMenuRight = () => {
            $('.filter-menu').css('transform', 'translate(-100%, 0%)');
            $('.filter-menu').css('display', 'block');
            $('.filter-menu').css('opacity', 0);
        
            // Force a reflow before animating
            $('.filter-menu')[0].offsetHeight;
            $('.filter-menu').css('opacity', 1);
            $('.filter-menu').css('transform', 'translateX(0%)');

            const qabContainer = document.getElementById('qab_container');
            if (qabContainer) {
              qabContainer.style.zIndex = '0';
            }
        
            $('.filter-menu').addClass('filter-right');
            $('html').addClass('js-drawer-open');
            $('body').addClass('js-drawer-open');
          };
        
          const hideFilterMenuLeft = () => {
            $('.filter-menu').css('transform', 'translate(-100%, 0%)');
            $('.filter-menu').css('opacity', 0);
            $('html').removeClass('js-drawer-open');
            $('body').removeClass('js-drawer-open');
          };
        
          const hideFilterMenuUp = () => {
            $('.filter-menu').css('transform', 'translateY(-100%)');
            $('.filter-menu').css('opacity', 0);
        
            setTimeout(() => {
              $('.filter-menu').css('display', 'none');
            }, 300);
          };
        
          const generateSortType = () => {
            switch (SORT_TYPE) {
              case 'newest':
                return '?sort_by=created-descending';
              case 'low-to-high':
                return '?sort_by=price-ascending';
              case 'high-to-low':
                return '?sort_by=price-descending';
              case 'best-selling':
                return '?sort_by=best-selling';
              default:
                return '';
            }
          };
        
          const generateFilters = (singleQuery) => {
            if (Object.keys(ACTIVE_FILTERS).length == 0) {
              return '';
            }

            let filterQuery = singleQuery ? '?' : '&';
            for (var i = 0; i < Object.keys(ACTIVE_FILTERS).length; i++) {
              if (i != 0) {
                filterQuery += '&';
              }
              filterQuery += Object.keys(ACTIVE_FILTERS)[i];
            }
        
            return filterQuery;
          };

          const handleFilterCount = () => {
            if (Object.keys(ACTIVE_FILTERS).length > 0) {
              let baseUrl = window.location.href.split('?')[0];
              let filters = generateFilters(false);
  
              let url = baseUrl + '?view=_filter-products-count' + filters;
              fetch(url)
                .then(response => response.text())
                .then(data => {
                  if (data && data.length > 0) {
                    let count = parseInt(data.replaceAll(' ', ''));
                    $('.filter-count').text(count);
                  }
                })
                .catch(error => {
                  console.error('Error:', error);
                });
            } else {
              $('.filter-count').text($('#filter-all-products-count').val());
            }
          };
        
          const handleFilterButtonVisibility = () => {
            if (Object.keys(ACTIVE_FILTERS).length == 0) {
              $('.filter-clear').hide();
            } else {
              $('.filter-clear').show();
            }
            handleFilterCount();
          };
        
          const generateFilterURL = () => {
            // loop through active filters keys and append
            let sort = generateSortType();
            let filters = generateFilters(sort == '' || !sort);
        
            // reset active filters
            ACTIVE_FILTERS = {};

            // if neither sort or filters, return just a ?
            if (sort == '' && filters == '') {
              window.location.href = '?';
              return;
            }

            let currLocation = window.location.href;
            let currLocationSplit = currLocation.split('?');
            if (currLocationSplit.length > 1) {
              currLocation = currLocationSplit[0];
            }
        
            window.location.href = currLocation + sort + filters;
            return sort + filters;
          };

          if (params) {
            let foundFilters = false;
            params.forEach((value, key) => {
              if (key == 'sort_by' || key.indexOf('filter') == -1) { return; };
              foundFilters = true;
              let amount = parseInt($(`input[data-filter="${key}=${value}"]`).parent().find('.filter-individual-count').text().replace('(', '').replace(')', ''));
              ACTIVE_FILTERS[`${key}=${value}`] = amount;
              $(`input[data-filter="${key}=${value}"]`).prop('checked', true);
              $('.filter-bar-inner').append('<span class="filter-bar-inner__item" data-key="' + key + '" data-value="' + value + '">' + value + ' <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"/></svg></span>');
            });

            if (foundFilters) {
              // show clear button
              $('.filter-clear').show();
              $('#filter-clear').show();
            }

            $('#filter-clear').click(function() {
              clearFilters();
              generateFilterURL();
            });
  
            handleFilterCount();
          }
        }
    },
    
    bodyClassCtl : function(e){
        // Please prevent operation on more then one drawer at the same time
        var self = this;
        var type = e.type;
        if (type == 'drawer-opt') {
            self.$body.toggleClass('drawer-opt');
            self.$body.toggleClass('show-overlay');
        } else {
            if (type == 'menu-opt-in') {
                self.$body.addClass('show-overlay');
            } else if (type == 'menu-opt-out') {
                self.$body.removeClass('show-overlay');
            }
        }
    },

    initMiniCart: function() {
        var self = this;
        var miniCartDrawerInit = function(){
            return OneDrawer.init({
                drawerElem: '#' + self.$miniCart.attr('id'),
                triggerEvent: 'click',
                triggerElem: 'header .block-minicart',
                openCallback: function(){ ajaxCart.load(); }
            });
        };
        var miniCartDropdownOpen = function(){
            self.$body.trigger('menu-opt-in');
            self.$header.find('.block-minicart').addClass('active');
        }
        var miniCartDropdownClose = function(){
            self.$header.find('.block-minicart').removeClass('active');
            self.$body.trigger('menu-opt-out');
        }
        
        self.miniCartCtl = miniCartDrawerInit();
        
        ajaxCart.init({
            formSelector: '.add-to-cart-form',
            addToCartSelector: '.add-to-cart-btn',
            cartContainer: '.minicart-container',
            cartCountSelector: '.minicart-count',
            cartCostSelector: '#CartCost',
            moneyFormat: theme.moneyFormat
        });
        
        if (self.miniCartAsDropdown) {
            // Init minicart as Dropdown on Desktop
            ajaxCart.load();
            
            ORW.utilities.mediaCheck(function () {
                if (self.miniCartCtl) {
                    self.miniCartCtl.destroy();
                    self.miniCartCtl = false;
                }
            }, function () {
                if (!self.miniCartCtl) {
                    self.miniCartCtl = miniCartDrawerInit();
                }
            })
        }
        // Listening for add to cart event from theme.js (to be changed into 'afterAddToCart.ajaxCart' when view-product.js is refactored)
        $(document.body).on('added.ajaxProduct', function(evt, cart) {
            if (self.miniCartCtl) {
                self.miniCartCtl.openDrawer();
                // self.miniCartTimer = setTimeout(function(){ self.miniCartCtl.closeDrawer(); }, 3000);
            } else {
                miniCartDropdownOpen();
                // self.miniCartTimer = setTimeout(function(){ miniCartDropdownClose(); }, 3000);
            }
        });
    },

    initUtilities: function() {
        var self = this;
        var events = {};
        
        // Header hover control (Larger screen)
        self.$header.hoverIntent({
            over: function(){
                if (!self.isMobile()) {
                    self.$body.trigger('menu-opt-in');
                }
            },
            out: function(){
                if (!self.isMobile()) {
                    self.$body.trigger('menu-opt-out');
                }
            },
            sensitivity: 100
        });
        
        // Header dropdown hover control (Larger screen)
        self.$header.hoverIntent({
            over: function(){
                if (!self.isMobile()) {
                    $(this).addClass('active');
                    if (self.miniCartTimer) {
                        // Check if minicart close timer exists, if so kill it.
                        clearTimeout(self.miniCartTimer);
                    }
                }
            },
            out: function(){
                if (!self.isMobile()) {
                    $(this).removeClass('active');
                }
            },
            sensitivity: 100,
            selector: '.has-dropdown:not(.block-search)'
        });
        
        // Copy extra links (if available) to Mobile menu utilities (Small screen)
        var $extraLinkContainer = self.$header.find('.header-extra-links');
        if ($extraLinkContainer.length) {
            $extraLinkContainer = $extraLinkContainer.clone();
            self.$mobileNav.find('.header-utilities').prepend($extraLinkContainer.html());
        }
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    isMobile: function () {
        if ( ORW.responsive == 'small') {
            return true;
        }
        return false;
    },

    devTools: function(){
        var self = this;
        var $indicator = $('#responsive-indicator');
        var $previewBar = $('#preview-bar-iframe');

         // This should only run when a theme is being previewed.
        if(Shopify.PreviewBarInjector !== undefined){
            if($indicator.length > 0 && $previewBar.length > 0 && Shopify.PreviewBarInjector.length == 1){
                $indicator.text("Preview: " + Shopify.theme.name).removeClass("hide");
                var events = {
                    'click #responsive-indicator': function(e){
                        $indicator.toggleClass('active');
                        $previewBar.toggleClass('active');
                    }
                };

                _.extend(self.events, events);
                self.delegateEvents();
            }else{
                $indicator.addClass("hide");
            }
        }
    }
});